export const fontStyle = "Roboto"
export const fontWeight = {
    thin: 300,
    medium: 500,
    semiBold: 700,
    bold: 'bold'
}